export const PermissionCodes = {
  ManageHangfire: 'MANAGE_HANGFIRE',
  ViewHealth: 'VIEW_HEALTH',
  ManageIdentity: 'MANAGE_IDENTITY',
  ManageOrganization: 'MANAGE_ORGANIZATION',
  ManageCache: 'MANAGE_CACHE',
  ManageSynchronization: 'MANAGE_SYNCHRONIZATION'
} as const;

export type PermissionCode = (typeof PermissionCodes)[keyof typeof PermissionCodes];
